import { Type } from "class-transformer";
import { Comparable } from "src/modules/utils/shared/comparable";
import { Dates } from "src/modules/utils/shared/dates";
import { Objects } from "src/modules/utils/shared/objects";

export class MissDayDto implements Comparable<MissDayDto> {
    pupilId = 0;
    @Type(() => Date)
    date: Date;
    hour: number;
    excused: boolean;
    lessonId = 0;

    constructor(pupilId: number, date: Date, hour: number, excused: boolean, lessonId: number) {
        this.pupilId = pupilId;
        this.date = date;
        this.hour = hour;
        this.excused = excused;
        this.lessonId = lessonId;
    }

    compareTo(other: MissDayDto): number {
        return Objects.cmpMulti([this.date, other.date, this.hour, other.hour]);
    }

    getNumDays(): number {
        return this.hour >= 0 ? 0.167 : 1;
    }

    getTitle(): string {
        return Dates.formatDefaultDate(this.date) + (this.hour >= 0 ? " " + (this.hour + 1) + ". Stunde" : "") + (this.excused ? " (E)" : "");
    }
}